import { Spinner } from "spin.js";
import { useEffect } from "react";

/**
 **** Reference for styling the Spin.js *****
 * @property  {number} lines: The number of lines to draw
 * @property  {number} length: The length of each line
 * @property  {number} width: The line thickness
 * @property  {number} radius: The radius of the inner circle
 * @property  {number} scale: Scales overall size of the spinner
 * @property  {number} corners:  Corner roundness (0..1)
 * @property  {number} speed: Rounds per second
 * @property  {number} rotate: The rotation offset
 * @property  {string} animation: The CSS animation name for the lines
 * @property  {number} direction: 1: clockwise, -1: counterclockwise
 * @property  {string} color: CSS color or array of colors
 * @property  {string} fadeColor: CSS color or array of colors
 * @property  {number} top:  Top position relative to parent
 * @property  {number} left: Left position relative to parent
 * @property  {string} shadow:  Box-shadow for the lines
 * @property  {number} zIndex:  The z-index (defaults to 2e9)
 * @property  {string} className: The CSS class to assign to the spinner
 * @property  {string} position: Element positioning
 */

const addSpinnerToElement = (element) => {
    const opts = {
            lines: 15,
            length: 35,
            width: 10,
            radius: 42,
            scale: 0.75,
            corners: 1,
            speed: 1.2,
            rotate: 0,
            animation: "spinner-line-fade-quick",
            direction: 1,
            color: "#000",
            fadeColor: "",
            top: "50%",
            left: "50%",
            shadow: "0 0 1px transparent",
            zIndex: 2e9,
            className: "spinner",
            position: "absolute"
        },
        loader = new Spinner(opts).spin();
    element.append(loader.el);
};

export function showLoaderForApp() {
    const loaderElement = document.getElementsByClassName("main-app-loader")[0];

    if (!loaderElement.hasChildNodes()) {
        addSpinnerToElement(loaderElement);
    }
}

export function hideLoaderForApp() {
    const loaderElement = document.getElementsByClassName("main-app-loader")[0];

    if (loaderElement?.firstChild) {
        loaderElement.removeChild(loaderElement.firstChild);
    }
}

export function showLoaderForSidePanel() {
    const sideAppElement = document.getElementsByClassName("main-spin-loader")[0];

    if (!sideAppElement.hasChildNodes()) {
        addSpinnerToElement(sideAppElement);
    }
    sideAppElement.style.display = "block";
}

export function hideLoaderForSidePanel() {
    const sideAppElement = document.getElementsByClassName("main-spin-loader")[0];

    if (sideAppElement) {
        if (sideAppElement.firstChild) {
            sideAppElement.removeChild(sideAppElement.firstChild);
        }
        sideAppElement.style.display = "none";
    }
}

export function InitialAppLoader() {
    useEffect(() => {
        showLoaderForApp();
    }, []);
    return null;
}

export function AppLoaderComponent() {
    useEffect(() => {
        showLoaderForSidePanel();
        return () => {
            hideLoaderForSidePanel();
        };
    });
    return null;
}
